import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Grid } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../../../../assets/styles/audio-question.css";
import Image from "../../../ui-components/Image";
import Audio from "../../../ui-components/Audio";

export default function CorrectOrder({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [answer, setAnswer] = React.useState(
		question.questionList.map((q) => q.choices)
	);

	React.useEffect(() => {
		setAnswer(question.questionList.map((q) => q.choices));
	}, [question]);

	const handleSetAnswer = (i, newOrder) => {
		let ans = [...answer];
		ans[i] = newOrder;
		setAnswer(ans);

		onAnswer({
			canProceed: true,
			answer: ans[0].map((a) => a.value),
		});
	};

	const onDragEnd = (result, i) => {
		if (!result.destination) return;

		const items = Array.from(answer[i]);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);

		handleSetAnswer(i, items);
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionImage && (
					<Image
						src={`${question.questionImage}`}
						alt="Question Illustration"
						style={{ width: "100%", marginTop: "20px" }}
                        allowFullscreen={true}
					/>
				)}
				{question.questionAudio && (
					<Audio audioText={question.questionAudio} />
				)}
				{question.questionList.map((k, i) => (
					<Grid
						container
						sx={{ mt: 2 }}
						key={`audio-question-${i}-${Math.random()}`}
					>
						<DragDropContext
							onDragEnd={(result) => onDragEnd(result, i)}
						>
							<Droppable droppableId={`droppable-${i}`}>
								{(provided) => (
									<div
										{...provided.droppableProps}
										ref={provided.innerRef}
										style={{ width: "100%" }}
									>
										{answer[i].map((choice, j) => (
											<Draggable
												key={`choice-${i}-${j}`}
												draggableId={`choice-${i}-${j}`}
												index={j}
											>
												{(provided) => (
													<div
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
														className="audio-question-container"
														style={{
															userSelect: "none",
															margin: "0 0 8px 0",
															...provided
																.draggableProps
																.style,
															justifyContent:
																choice?.image
																	? "start"
																	: "center",
															borderRadius:
																"10px",
														}}
													>
														{choice?.image && (
															<Image
																src={
																	choice?.image
																}
																style={{
																	maxWidth:
																		"5rem",
																}}
															/>
														)}
														<Typography
															sx={{
																display: "flex",
																alignItems:
																	"center",
																color: theme
																	.palette
																	.primary
																	.main,
																fontWeight:
																	"bold",
																px: 2,
																py: 1,
																cursor: "pointer",
																justifyContent:
																	"center",
																textAlign:
																	choice?.image
																		? "left"
																		: "center",
															}}
														>
															{choice.label ||
																choice.value}
														</Typography>
													</div>
												)}
											</Draggable>
										))}
										{provided.placeholder}
									</div>
								)}
							</Droppable>
						</DragDropContext>
					</Grid>
				))}
			</Box>
		</React.Fragment>
	);
}
